import { render } from "./EditLotNote.vue?vue&type=template&id=48bc1ba4&scoped=true"
import script from "./EditLotNote.vue?vue&type=script&lang=js"
export * from "./EditLotNote.vue?vue&type=script&lang=js"

import "./EditLotNote.vue?vue&type=style&index=0&id=48bc1ba4&lang=css"
import "./EditLotNote.vue?vue&type=style&index=1&id=48bc1ba4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48bc1ba4"]])

export default __exports__